export const selectBankEntities = store => store.bank?.bankEntities;
